import { useTranslation } from "react-i18next";
import { FormContactsDataList } from "@/pages/ContactsPage/Components/FormContactsDataList";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { handlePeriod } from "@/shared/utils/handle-contacts-null";
import { Competences, Education, Hobbies } from "../Fields";

export const RightSectionList = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);
  if (!currentPerson) return <></>;

  return (
    <>
      <FormContactsDataList
        title={t("contactsPage.activities.education")}
        fieldArrayName={"educations"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.school ?? "",
          subLabel: handlePeriod(item?.educationStart, item?.educationEnd),
          value: item?.major ?? "",
          about: item?.about ?? "",
        })}
        editNode={(index) => <Education index={index} />}
        addableModel={{
          id: "",
          place: "",
          personId: currentPerson.id,
          major: "",
          educationStart: "",
          educationEnd: "",
          additional: "",
        }}
      />
      <FormContactsDataList
        title={t("contactsPage.activities.competences")}
        fieldArrayName={"competences"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.competenceType?.name ?? "",
          value: item?.about ?? "",
        })}
        editNode={(index) => <Competences index={index} />}
        addableModel={{
          id: "",
          about: "",
          personId: currentPerson?.id,
          competenceType: {
            name: "",
          },
        }}
      />
      <FormContactsDataList
        title={t("contactsPage.activities.hobbies")}
        fieldArrayName={"hobbies"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.hobbyType?.name ?? "",
          value: item?.about ?? "",
        })}
        editNode={(index) => <Hobbies index={index} />}
        addableModel={{
          id: "",
          personId: currentPerson.id,
          about: "",
          hobbyType: {
            name: "",
          },
        }}
      />
    </>
  );
};
